export const viewsEs = {
  Home: {
    providers: 'Proveedores',
  },
  AllGames: {
    title: 'Juegos',
  },
  Provider: {},
}